import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';

const datePickerLang = {
	es,
	ca
};

export default datePickerLang;
